var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForumIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.70251 14.4713V2.55376C1.70251 2.31258 1.78423 2.11026 1.94767 1.94682C2.11055 1.78395 2.31258 1.70251 2.55376 1.70251H13.62C13.8612 1.70251 14.0632 1.78395 14.2261 1.94682C14.3895 2.11026 14.4713 2.31258 14.4713 2.55376V10.215C14.4713 10.4562 14.3895 10.6582 14.2261 10.8211C14.0632 10.9845 13.8612 11.0663 13.62 11.0663H5.10751L1.70251 14.4713ZM5.95876 15.3225C5.71758 15.3225 5.51526 15.2408 5.35182 15.0774C5.18895 14.9145 5.10751 14.7125 5.10751 14.4713V12.7688H16.1738V5.10751H17.8763C18.1175 5.10751 18.3195 5.18895 18.4824 5.35182C18.6458 5.51526 18.7275 5.71758 18.7275 5.95876V18.7275L15.3225 15.3225H5.95876Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForumIcon);
export default __webpack_public_path__ + "static/media/ForumIcon.a440d3493669b6ad997815abc7e5a823.svg";
export { ForwardRef as ReactComponent };